module.exports = __webpack_public_path__ + "static/img/4.539d96a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/4.png
// module id = zicp
// module chunks = 0